import { createFileRoute, useNavigate } from '@tanstack/react-router';

import { usePaymentList } from '@/features/student-management/hooks/usePaymentList';
import { PaymentFilterBar } from '@/features/student-management/ui/molecules/PaymentFilterBar';
import { PaymentTable } from '@/features/student-management/ui/organisms/PaymentTable';
import { PaymentListTemplate } from '@/features/student-management/ui/templates/PaymentListTemplate';

export const Route = createFileRoute('/_authenticated/persons/payments/')({
  component: PaymentListPage,
});

function PaymentListPage() {
  const navigate = useNavigate();
  const { data, isLoading } = usePaymentList();

  return (
    <PaymentListTemplate
      filterPanel={<PaymentFilterBar />}
      table={
        <PaymentTable
          data={data}
          isLoading={isLoading}
          onEditPlan={planId =>
            void navigate({
              to: '/persons/payments/plans/$planId',
              params: { planId: String(planId) },
            })
          }
          onViewParcels={planId =>
            void navigate({
              to: '/persons/payments/plans/$planId/parcels',
              params: { planId: String(planId) },
            })
          }
          onCancelPlan={_planId => {}}
          onAddPlan={_personId => {}}
        />
      }
    />
  );
}
